import keyMirror from "keymirror";

export const LocalizationConstants = {
  ActionTypes: keyMirror({
    SET_TRANSLATE: null,
    NONE: null
  })
}; 
